<template>
  <div class="login-container">
    <div class="login-box">
      <h1>Admin Login</h1>
      <form @submit.prevent="login">
        <div class="input-group">
          <label for="email">Email</label>
          <input type="email" id="email" v-model="email" required />
        </div>
        <div class="input-group">
          <label for="password">Password</label>
          <input type="password" id="password" v-model="password" required />
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
        <button type="submit" class="submit-button">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

export default {
  name: 'LoginView', // Added name property
  setup() {
    const email = ref('');
    const password = ref('');
    const error = ref(null);
    const router = useRouter();
    const auth = getAuth();

    const login = async () => {
      error.value = null;
      try {
        await signInWithEmailAndPassword(auth, email.value, password.value);
        console.log('Login successful, redirecting to /admin'); // Added console.log
        router.push('/admin');
      } catch (e) {
        error.value = e.message;
      }
    };

    return {
      email,
      password,
      error,
      login,
    };
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background: transparent;
}
.login-box {
  background: rgba(255, 255, 255, 0.95);
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  text-align: center;
}
h1 {
  color: #333;
  margin-bottom: 25px;
}
.input-group {
  margin-bottom: 20px;
  text-align: left;
}
label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 600;
}
input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
}
.submit-button {
  width: 100%;
  padding: 15px;
  background-color: #e91e63;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}
.submit-button:hover {
  background-color: #c2185b;
}
.error-message {
  color: #d32f2f;
  margin-bottom: 15px;
}
</style>
